import { userRoleObj } from "utils/constants";
import {
  leadTypeObj,
  sidebarSubMenuObj,
  pathnameObj,
  token,
  property,
  withoutSubmenuItems,
  staffTarget,
  tasks,
  project,
  teams,
  projectProperties,
  individualProperties,
  keysToHideFromUser,
  importLeads,
  allLeadsBulk,
  rawLeadsBulk,
  polishLeadsBulk,
} from "./constants";

const {
  leadDetail,
  tokenDetail,
  propertyDetail,
  staffTargetDetail,
  taskDetail,
  projectDetail,
  teamDetail,
  userDetail,
} = pathnameObj;

export function isMainMenu(key: string) {
  return sidebarSubMenuObj.mainMenu.includes(key);
}

export function isSubMenu(key: string) {
  return sidebarSubMenuObj.subMenu.includes(key);
}

export function checkForOpenMenu({ pathname }: any): boolean {
  return (
    withoutSubmenuItems.filter((itemPath) => itemPath === pathname).length ||
    pathname?.includes(leadDetail) ||
    pathname?.includes(tokenDetail) ||
    pathname?.includes(propertyDetail) ||
    pathname?.includes(staffTargetDetail) ||
    pathname?.includes("customer") ||
    pathname?.includes(taskDetail) ||
    pathname?.includes(projectDetail) ||
    pathname?.includes(teamDetail) ||
    pathname?.includes(userDetail)
  );
}

export function handleActivRouteBasedOnDetailRoute({ item, pathname }: any) {
  if (pathname.includes(staffTargetDetail)) {
    return item?.key === staffTarget;
  }

  return false;
}

export function handleActivMenuBasedOnRoute({ search, item, pathname }: any) {
  if (pathname.includes(leadDetail)) {
    if (search && Object.values(leadTypeObj).includes(item.key)) {
      const newParams = new URLSearchParams(search);
      const leadType = newParams.get("type");

      return leadType ? leadTypeObj[leadType] === item.key : false;
    }
  }

  if (pathname.includes(tokenDetail)) {
    return item?.key === token;
  }

  if (pathname.includes(propertyDetail)) {
    const newParams = new URLSearchParams(search);
    const isProjectProperty = newParams.get("isProjectProperty");
    return isProjectProperty === "true"
      ? item?.key === projectProperties
      : item?.key === individualProperties;
  }

  if (pathname.includes(staffTargetDetail)) {
    return item?.key === staffTarget;
  }

  if (pathname.includes(taskDetail)) {
    return item?.key === tasks;
  }

  if (pathname.includes(projectDetail)) {
    return item?.key === projectProperties;
  }

  if (pathname.includes(teamDetail)) {
    return item?.key === teams;
  }

  if (pathname.includes(userDetail)) {
    return item?.key === teams;
  }
  return false;
}

export function aggregateUserSettings(data: any = {}) {
  const result = Object.entries(data).reduce(
    (emptyObj: any, [key, value]: any) => {
      switch (true) {
        case key?.includes("theme"):
          emptyObj.theme.push({ key, value });
          break;
        // analysis_and_reports added to remove from settings popup
        case ["user", "id", "resource_uri", "analysis_and_reports"].includes(
          key
        ):
          break;

        default:
          emptyObj.sidebar.push({ key, value });
          break;
      }

      return emptyObj;
    },
    {
      sidebar: [],
      theme: [],
    }
  );

  return result;
}

export function isLinkToShowBasedOnRole({
  role,
  key,
}: {
  role: string;
  key: string;
}): boolean {
  if (keysToHideFromUser.includes(key)) {
    return role !== userRoleObj?.user;
  }

  return true;
}
